import { Ban, CreditCard, Truck } from "lucide-react";
import { observer } from "mobx-react";
import React from "react";
import { Button } from "randmarcomps";
import withManufacturer from "../../contexts/WithManufacturer";
import Return from "../../stores/return/Return";

interface IProps {
  returnDocument: Return;
  applicationId: string;
}

const SingleReturnActions: React.FC<IProps> = ({ returnDocument }) => {
  //if (createLabel) return (<Navigate to={Path.category(applicationId, product?.category)} />);

  return (
    <div className="flex flex-col gap-1 mx-1 my-2 max-w-[250px]">
      <h3 className="ml-1 text-sm font-medium text-primary">
        Return {returnDocument.returnNumber}
      </h3>
      <Button variant="ghost" disabled className="justify-start gap-2 px-2">
        <Ban className="w-4 h-4" />
        <span>Decline</span>
      </Button>
      <Button variant="ghost" disabled className="justify-start gap-2 px-2">
        <CreditCard className="w-4 h-4" />
        <span>Credit</span>
      </Button>

      <hr className="my-1" />

      <h3 className="ml-1 text-sm font-medium text-primary">
        Utilities
      </h3>
      <Button variant="ghost" disabled className="justify-start gap-2 px-2">
        <Truck className="w-4 h-4" />
        <span>Create Return Label</span>
      </Button>
    </div>
  );
};

export default withManufacturer(observer(SingleReturnActions));
